<template>
    <div class="upload-image">
        <p class="upload-tips">反馈页面截图，最多五张(选填)</p>
        <ul class="img-list">
            <li v-for="(url, index) in imgList" v-show="imgList.length" :key="index" class="img-item">
                <img :src="url.file.src" />
                <p class="del-icon" @click="delImg(index)">
                    <icon name="input-delete"></icon>
                </p>
            </li>
            <li v-show="!outLimit" class="add-image" @click="chooseImg">
                <img src="@/assets/images/feedback/camera.png" />
            </li>
        </ul>
        <input id="upload_file" type="file" accept="image/*" style="display: none" @change="fileChange($event)" />
    </div>
</template>

<script>
import ajax from '../../api/ajax'

export default {
    name: 'FeedbackUpload',
    props: ['title'],
    data() {
        return {
            imgList: [],
            outLimit: false,
            limit: 5, // 图片上传数量
            size: 0,
            photoUrls: {} // 图片地址
        }
    },
    watch: {
        imgList: function () {
            this.imgList.length < 5 ? (this.outLimit = false) : (this.outLimit = true)
        }
    },
    methods: {
        chooseImg() {
            document.getElementById('upload_file').click()
        },
        fileChange(el) {
            if (!el.target.files[0].size) {
                return
            }
            this.fileList(el.target)
            el.target.value = ''
        },
        fileList(fileList) {
            const files = fileList.files
            for (let i = 0; i < files.length; i++) {
                this.fileAdd(files[i])
            }
        },
        fileAdd(file) {
            if (this.limit !== undefined) {
                this.limit--
            }
            if (this.limit !== undefined && this.limit < 0) {
                return
            }
            // 总大小
            this.size = this.size + file.size
            const reader = new FileReader()
            const image = new Image()
            const _this = this
            reader.readAsDataURL(file)
            reader.onload = function () {
                // 按比例压缩图片
                _this.compressImage(
                    this.result,
                    imgData => {
                        image.onload = function () {
                            const width = image.width
                            const height = image.height
                            file.src = imgData
                            file.width = width
                            file.height = height
                            _this.imgList.push({ file })
                        }
                        image.src = imgData
                    },
                    file.size,
                    1024 * 1024
                )
            }
        },
        /**
         * 删除图片
         */
        delImg(index) {
            this.size = this.size - this.imgList[index].file.size // 总大小
            this.imgList.splice(index, 1)
            if (this.limit !== undefined) {
                this.limit = 5 - this.imgList.length
            }
        },
        dataURLtoFile(dataurl, filename) {
            // 将base64转换为文件
            const arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, { type: mime })
        },
        /**
         * 压缩图片
         * @param imgData
         * @param callback
         * @param fileSize
         * @param maxSize
         */
        compressImage(imgData, callback, fileSize, maxSize) {
            //	大于1MB的图片才压缩
            if (!fileSize || fileSize < maxSize) {
                callback(imgData)
                return
            }
            const imageSource = new Image()
            imageSource.src = imgData
            imageSource.onload = function () {
                // 区分图片对象，赋值 that
                const that = this
                /**
                 * 默认按比例压缩
                 * 压缩比例 = 最大图片大小 / 当前图片大小
                 */
                let [width, height, quality] = [that.width, that.height, maxSize / fileSize]
                //	生成 canvas 创建属性节点
                const [canvas, anw, anh] = [document.createElement('canvas'), document.createAttribute('width'), document.createAttribute('height')]
                anw.nodeValue = width
                anh.nodeValue = height
                const ctx = canvas.getContext('2d')
                canvas.setAttributeNode(anw)
                canvas.setAttributeNode(anh)
                ctx.drawImage(that, 0, 0, anw.nodeValue, anh.nodeValue)
                // quality值越小，所绘制出的图像越模糊,当接近的时候反而会数据会翻倍
                if (quality > 0.5) {
                    quality = 0.5
                } else if (quality < 0.01) {
                    quality = 0.01
                }
                const base64 = canvas.toDataURL('image/jpeg', quality)
                const [filesize, maxfileSize, zoomouSize] = [fileSize / 1024, maxSize / 1024, base64.length / 1024]
                console.log(
                    `当前原文件大小：${filesize}(KB), 最大maxSize= ${maxfileSize}(KB),  压缩quality：${quality} ,压缩后新图片大小：${zoomouSize}(KB)`
                )
                // 将压缩的图片结果返回
                callback(base64)
            }
        },
        imgUpload(params) {
            const view = this
            this.$loading('')
            const formData = new FormData()
            // eslint-disable-next-line no-undef
            _.each(this.imgList, function (file) {
                formData.append('files', view.dataURLtoFile(file.file.src, file.file.name))
            })
            ajax.feedBackUpload({
                dataType: 'json',
                data: formData,
                contentType: false,
                cache: false,
                processData: false
            })
                .then(res => {
                    // eslint-disable-next-line no-undef
                    _.each(res.data.obj, function (str, index) {
                        view.photoUrls[`photoUrl${index + 1}`] = str
                    })
                    view.postSuggestion(params)
                })
                .catch(res => {
                    view.$toast('网络错误')
                })
                .finally(() => {
                    view.$loading()
                })
        },
        // 提交建议(传递数据)
        postSuggestion(params) {
            const photos = this.photoUrls
            const view = this
            Object.assign(params, photos)
            ajax.postSuggestion({ data: params })
                .then(res => {
                    view.$router.push({ name: 'feedbackSucceed', params: { sourceTitle: view.title } })
                })
                .catch(res => {
                    view.$toast('网络错误')
                })
        },
        // 提交(获取图片Url)
        postOrUpload(params) {
            if (this.size === 0) {
                this.postSuggestion(params)
            } else {
                this.imgUpload(params)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-image {
    margin-top: 0.2rem;
    color: $gray;
    .upload-tips {
        margin-bottom: 0.3rem;
    }
    .add-image {
        display: inline-block;
        width: 1.44rem;
        height: 1.44rem;
        background: $bg-gray;
        position: relative;
        img {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -0.32rem;
            margin-left: -0.32rem;
        }
    }
    .img-list {
        display: inline-block;
        .img-item {
            position: relative;
            float: left;
            margin-right: 0.2rem;
            img {
                width: 1.44rem;
                height: 1.44rem;
            }
            .del-icon {
                position: absolute;
                right: -0.15rem;
                top: -0.15rem;
            }
            .icon-input-delete {
                width: 0.3rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedback-upload.vue